import { z } from "zod";

export const externalID = (errMsg?: string) =>
  z.string().min(1, errMsg || "External ID must be at least 1 character long");
